import { TabNav as TabNav$1 } from '@primer/react/deprecated';
import sx from '../../sx.js';
import styled from 'styled-components';
import { forwardRef } from 'react';
import { jsx } from 'react/jsx-runtime';

const StyledTabNav = styled(TabNav$1).withConfig({
  shouldForwardProp: prop => prop !== 'sx'
}).withConfig({
  displayName: "TabNav__StyledTabNav",
  componentId: "sc-13kad3t-0"
})(["", ""], sx);
const TabNavImpl = ({
  as,
  ...props
}) => {
  return /*#__PURE__*/jsx(StyledTabNav, {
    ...props,
    ...(as ? {
      forwardedAs: as
    } : {})
  });
};
const StyledTabNavLink = styled(TabNav$1.Link).withConfig({
  shouldForwardProp: prop => prop !== 'sx'
}).withConfig({
  displayName: "TabNav__StyledTabNavLink",
  componentId: "sc-13kad3t-1"
})(["", ""], sx);
const TabNavLink = /*#__PURE__*/forwardRef(({
  as,
  ...props
}, ref) => /*#__PURE__*/jsx(StyledTabNavLink, {
  ...props,
  ...(as ? {
    forwardedAs: as
  } : {}),
  ref: ref
}));
const TabNav = Object.assign(TabNavImpl, {
  Link: TabNavLink
});

export { TabNav };
